export interface MenuCategorySelection {
    currentCategoryId: number | null;
    currentSubcategoryId: number | null;
}

export const createEmptyCategorySelection = (): MenuCategorySelection => ({
    currentCategoryId: null,
    currentSubcategoryId: null,
});

export const resolveMenuCategoryId = (category: MenuCategorySelection): number | null =>
    category.currentSubcategoryId ?? category.currentCategoryId ?? null;
